<template>
  <div class="app-container">


    <div :class="showType ? 'banner__layer' : 'banner__layer bannerss'">

      <!-- <img class="banner-img" src="@/assets/imgs/banner3.png" /> -->
      <!-- <img class="banner-imgs" src="@/assets/imgs/banner4.png" /> -->


      <div :class="showType ? 'banner-content content-box' : 'banner-content content-box banner-co'">
        <img class="top-img" src="../../../../static/index/top-app.png" alt="" />
        <img class="waplogo" src="../../../../static/common/waplogo.png" alt="">
        <h1 class="title"> 选对产品 选对平台</h1>
        <h1 class="titles">选对产品 </h1>
        <h1 class="titles">选对平台</h1>
        <p class="banner-content-intro">香港黄金交易所权威授权 · 您的信赖之选</p>
        <div class="banner-content-download">
          <router-link to="/Appdownload?key=1">
            <span class="banner-content-download-btn">APP下载</span>
            <span class="banner-content-download-btn1">立即下载 →</span>
          </router-link>

        </div>
        <div class="banner-content-download-text">
          <div>
            <img src="@/assets/imgs/mobie-icon.png" alt="">
            <span>
              支持多平台 <br />
              双端互通
            </span>
          </div>
          <div>
            <img src="@/assets/imgs/user-black-icon.png" alt="">
            <span>
              简单 <br />
              易用
            </span>
          </div>
        </div>
      </div>

    </div>

    <div class="sub-menu">
      <div v-for="item in menuList" :class="`sub-menu-item ${activeMenu === item.key && 'sub-menu-item-active'}`"
        :key="'sub-menu-' + item.key" @click="handleMenu(item)" :style="`
          ${activeMenu === item.key && activeMenu === '1' && 'border-top-left-radius: 4px;border-bottom-left-radius: 4px;'}
          ${activeMenu === item.key && activeMenu === '4' && 'border-top-right-radius: 4px;border-bottom-right-radius: 4px;'}
        `">
        <div>
          <img :src="activeMenu === item.key ? item.selectIcon : item.icon" alt="">
          <span>{{ item.name }}</span>
        </div>
      </div>
    </div>

    <div class="content-box">
      <keep-alive>
        <product-first v-if="activeMenu === '1'"></product-first>
      </keep-alive>
      <keep-alive>
        <product-second v-if="activeMenu === '2'"></product-second>
      </keep-alive>
      <keep-alive>
        <product-third v-if="activeMenu === '3'"></product-third>
      </keep-alive>
      <keep-alive>
        <product-fourth v-if="activeMenu === '4'"></product-fourth>
      </keep-alive>
    </div>


  </div>
</template>

<script>

import ProductFirst from './components/productFirst';
import ProductSecond from './components/productSecond';
import ProductThird from './components/productThird';
import ProductFourth from './components/productFourth';
import MenuIcon1 from '@/assets/imgs/menu1.png'
import MenuIcon2 from '@/assets/imgs/menu2.png'
import MenuIcon3 from '@/assets/imgs/menu3.png'
import MenuIcon4 from '@/assets/imgs/menu4.png'
import MenuSelectIcon1 from '@/assets/imgs/menu-select1.png'
import MenuSelectIcon2 from '@/assets/imgs/menu-select2.png'
import MenuSelectIcon3 from '@/assets/imgs/menu-select3.png'
import MenuSelectIcon4 from '@/assets/imgs/menu-select4.png'

export default {
  name: 'Product',

  components: {

    ProductFirst,
    ProductSecond,
    ProductThird,
    ProductFourth,
  },
  data() {
    return {
      activeMenu: this.$route.query.key || '1',
      menuList: [
        { name: '产品介绍', key: '1', icon: MenuIcon1, selectIcon: MenuSelectIcon1 },
        { name: '账户介绍', key: '2', icon: MenuIcon2, selectIcon: MenuSelectIcon2 },
        { name: '产品细则', key: '3', icon: MenuIcon3, selectIcon: MenuSelectIcon3 },
        { name: '今日汇率', key: '4', icon: MenuIcon4, selectIcon: MenuSelectIcon4 },
      ],
      showType: true
    }
  },
  watch: {
    $route(nv) {
      this.activeMenu = nv.query.key;
    }
  },
  created() {
    if (this.$route.query.from) {
      this.showType = false

    };
    this.$emit('controlShow', false);

  },
  mounted() {

  },
  methods: {
    handleMenu(item) {
      this.activeMenu = item.key
    },
  },
}
</script>
<style lang="less" scoped>
.app-container {
  background: #fafafa;

  .content-box {
    width: 1240px;
    margin: auto;
    box-sizing: border-box;
  }

  .banner__layer {
    width: 100%;
    height: 810px;
    background:linear-gradient(100.69deg, rgba(0, 0, 0, 0.6) 27.87%, rgba(10, 10, 10, 0) 72.52%, rgba(10, 10, 10, 0.2) 100%), url('../../../assets/imgs/banner3.png') no-repeat;
    background-size: 100% 100%;

    // padding-top: 80px;
    .banner-img {
      display: block;
      width: 100%;
      height: 810px;
    }

    .banner-imgs {
      display: none;
      width: 100%;
    }

    .banner-content {
      padding-top: 163px;
      width: 1240px;
      margin: 0 auto;
      color: #FFFFFF;

      .top-img {
        width: 139px;
        height: 38px;
      }

      .waplogo {
        display: none;
      }

      .title {
        display: block;
        font-size: 80px;
        font-weight: 700;
        line-height: 106px;
        margin: 34px 0 26px 0;
      }

      .titles {
        display: none;
      }

      h1 {
        font-size: 68px;
        margin: 0;
      }

      &-intro {
        font-size: 18px;
        font-size: 26px;

        line-height: 34px;
      }

      &-download {
        display: flex;
        align-items: center;
        margin-top: 50px;

        &-btn {
          width: 198px;
          line-height: 56px;
          color: #FFFFFF;
          background: #FA2314;
          border-radius: 100px;

          cursor: pointer;
          text-align: center;
          font-size: 20px;
          font-weight: 700;
          display: inline-block;
          margin-bottom: 54px;
        }
        &-btn1{
          display: none;
        }

        &-text {
          display: flex;
          align-items: center;

          >div {
            display: flex;
            align-items: center;
            color: #FFFFFF;
            // padding: 4px 40px;

            &:first-child {
              padding-right: 32px;
              border-right: 1px solid #0F0F11;
            }

            &:last-child {
              padding-left: 32px;
            }

            img {
              width: 38px;
              height: 38px;
              margin-right: 12px;
            }
          }
        }
      }
    }
  }

  .title__layer {
    text-align: center;
    padding: 70px 0 50px;

    h1 {
      font-size: 46px;
      margin: 0;
      color: #000;
      margin-bottom: 10px;

      span {
        color: #FA2314;
      }
    }

    p {
      color: #0F0F11;
      font-size: 18px;
    }
  }

  .sub-menu {
    width: 1240px;
    position: relative;
    margin: -50px auto 80px;
    display: flex;
    background: #FFFFFF;
    border-radius: 4px;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);

    &-item {
      cursor: pointer;
      width: 25%;
      color: #000;
      position: relative;
      font-size: 20px;
      padding: 20px 0;

      >div {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 44px;
        border-right: 1px solid #C9C9CF;

      }

      &:last-child {
        >div {
          border: none;
        }
      }

      img {
        display: block;
        margin-right: 10px;
      }
    }

    &-item-active {
      background: #FA2314;
      color: #FFFFFF;

      >div {
        border-right: 0px;
      }

      &::after {
        content: "";
        position: absolute;
        bottom: -10px;
        left: 0;
        width: 0;
        height: 0;
        right: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid #FA2314;
        margin: auto;
      }
    }

  }

}

@media screen and (max-width: 500px) {
  .app-container {
    .banner__layer {
      // padding-top: 45px;
      background: url('../../../assets/imgs/banner4.png') no-repeat;
      background-size: 100% 100%;
      height: 705px;

      .banner-img {
        display: none;
      }

      .banner-imgs {
        display: block;
        height: 500px;

      }

      .banner-content {
        width: 100%;
        margin: 0 auto;
        padding: 40px 0;
        background: linear-gradient(160.28deg, rgba(0, 0, 0, 0.8) 9.03%, rgba(0, 0, 0, 0.56) 47.92%, rgba(6, 6, 6, 0) 72.9%, rgba(10, 10, 10, 0.2) 100%);
        color: #FFFFFF;

        .waplogo {
          display: block;
          width: 110px;
          height: 30px;
          margin: 0 auto;
        }

        .top-img {
          display: none;
        }

        .title {
          display: none;
        }

        .titles {
          color: #FFFFFF;
          display: block;
        }

        h1 {
          font-size: 58px;
          line-height: 77px;
          margin: 0;
          width: 100%;
          text-align: center;
          white-space: wrap;
        }

        &-intro {
          font-size: 14px;
          text-align: center;
        }

        &-download {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-top: 20px;

          &-btn {
            display: none;
          }

          &-btn1 {
            display: block;
            width: 180px;
            line-height: 34px;
            color: #FFFFFF;
            background: #FA2314;
            border-radius: 100px;

            cursor: pointer;
            text-align: center;
            font-size: 14px;
            font-weight: 700;

          }

          &-text {
            display: none;
          }
        }
      }

      .banner-co {
        top: 33%;
      }

    }

    .bannerss {
      padding-top: 0;
    }

    .content-box {
      width: 100%;
      margin: auto;
      box-sizing: border-box;
    }

    .title__layer {
      .title {
        display: none;
      }

      .titles {
        display: block;
      }

      h1 {
        font-size: 36px;
        line-height: 48px;
      }

      p {
        font-size: 14px;
      }
    }

    .sub-menu {
      width: 80%;
      margin: -27px auto 80px;

      &-item {
        font-size: 12px;
        padding: 10px 0;

        >div {
          height: 17px;
        }

        img {
          display: none;
        }
      }

      &-item-active {
        &::after {
          bottom: -5px;
        }
      }
    }
  }
}

// -------------------------小屏幕适配-------------------
@media screen and (min-width: 1264px) and (max-width: 1724px) {
  .app-container {
    background: #fafafa;

    .content-box {
      width: 1000px;
      margin: auto;
      box-sizing: border-box;
    }

    .banner__layer {
      position: relative;
      // padding-top: 80px;

      .banner-img {
        display: block;
        width: 100%;
      }

      .banner-imgs {
        width: 100%;

        display: none;
      }

      .banner-content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 11;
        color: #FFFFFF;

        .title {
          display: block;
        }

        .titles {
          display: none;
        }

        h1 {
          font-size: 50px;
          margin: 0;
        }

        &-intro {
          font-size: 18px;
        }

        &-download {
          display: flex;
          align-items: center;
          margin-top: 50px;

          &-btn {
            width: 198px;
            line-height: 56px;
            color: #FFFFFF;
            background: #FA2314;
            border-radius: 4px;
            margin-right: 10px;
            cursor: pointer;
            text-align: center;
            font-size: 20px;
            font-weight: 700;
            display: inline-block;
          }

          &-text {
            display: flex;
            align-items: center;

            >div {
              display: flex;
              align-items: center;
              color: #FFFFFF;
              padding: 4px 40px;

              &:first-child {
                border-right: 1px solid #0F0F11;
              }

              img {
                width: 38px;
                height: 38px;
                margin-right: 12px;
              }
            }
          }
        }
      }
    }

    .title__layer {
      text-align: center;
      padding: 70px 0 50px;

      h1 {
        font-size: 46px;
        margin: 0;
        color: #000;
        margin-bottom: 10px;

        span {
          color: #FA2314;
        }
      }

      p {
        color: #0F0F11;
        font-size: 18px;
      }
    }

    .sub-menu {
      width: 1000px;
      position: relative;
      margin: -50px auto 80px;
      display: flex;
      background: #FFFFFF;
      border-radius: 4px;
      box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);

      &-item {
        cursor: pointer;
        width: 25%;
        color: #000;
        position: relative;
        font-size: 20px;
        padding: 20px 0;

        >div {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 44px;
          border-right: 1px solid #C9C9CF;

        }

        &:last-child {
          >div {
            border: none;
          }
        }

        img {
          display: block;
          margin-right: 10px;
        }
      }

      &-item-active {
        background: #FA2314;
        color: #FFFFFF;

        >div {
          border-right: 0px;
        }

        &::after {
          content: "";
          position: absolute;
          bottom: -10px;
          left: 0;
          width: 0;
          height: 0;
          right: 0;
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          border-top: 10px solid #FA2314;
          margin: auto;
        }
      }

    }

  }
}
</style>